// extracted by mini-css-extract-plugin
export default {"ReadonlyQuestions":"styles_ReadonlyQuestions__ToCrX","question":"styles_question__5wLdI","row":"styles_row__vdYhu","col":"styles_col__815Qq"};